import { Injectable } from '@angular/core';
import { UserInfoConfigurationService } from '../configuration/user-info/user-info-configuration.service';
import { OpengroundCloudHttpClient } from '../http/openground-cloud-http-client.service';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {

  get configuration() {
    return this.userInfoConfigurationService.configuration;
  }

  get url() {
    return this.configuration.url;
  }

  constructor(private userInfoConfigurationService: UserInfoConfigurationService, private http: OpengroundCloudHttpClient) { }

  getUserInfo() {
    return this.http.get(this.url, {
      addInstanceIdHeader: false,
      addFeatureTrackingHeaders: false,
      addSuperBatmanHeader: false
    });
  }

}
